import LegalLayout, { Section } from "./LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout eyebrow="Legal" title="Privacy Policy" version="v1.0" effective="February 14, 2026">
      <div
        className="border border-volt/40 bg-volt/5 p-4 text-volt text-sm leading-relaxed"
        data-testid="privacy-placeholder-notice"
      >
        This Privacy Policy is placeholder content and should be reviewed by a qualified lawyer before launch.
      </div>

      <Section heading="1. Introduction" testid="privacy-introduction">
        <p>
          This Privacy Policy explains how PITCHD collects, uses, stores, and shares personal information.
        </p>
      </Section>

      <Section heading="2. Information We Collect" testid="privacy-info-collected">
        <p>PITCHD may collect:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>account information</li>
          <li>athlete profile information</li>
          <li>social media links</li>
          <li>sponsorship goals</li>
          <li>brand contact details added by users</li>
          <li>usage data</li>
          <li>billing data</li>
          <li>AI prompt inputs and generated outputs</li>
          <li>communication and support data</li>
        </ul>
      </Section>

      <Section heading="3. How We Use Information" testid="privacy-how-we-use">
        <p>PITCHD uses information to:</p>
        <ul className="list-disc pl-6 space-y-2">
          <li>provide the platform</li>
          <li>generate media kits and outreach</li>
          <li>manage user accounts</li>
          <li>process payments</li>
          <li>improve product functionality</li>
          <li>personalize user experience</li>
          <li>support sponsorship workflows</li>
          <li>maintain platform security</li>
        </ul>
      </Section>

      <Section heading="4. AI Processing" testid="privacy-ai-processing">
        <p>
          Information submitted by users may be processed using third-party AI providers to generate content,
          summaries, recommendations, media kits, outreach messages, and sponsorship-related outputs.
        </p>
      </Section>

      <Section heading="5. Public Profiles" testid="privacy-public-profiles">
        <p>
          If users enable public athlete profiles or share media kits, selected profile information may be
          visible to brands, agencies, managers, or other third parties.
        </p>
      </Section>

      <Section heading="6. Data Sharing" testid="privacy-data-sharing">
        <p>
          PITCHD may share information with service providers such as hosting providers, payment processors,
          analytics tools, authentication providers, and AI infrastructure providers.
        </p>
      </Section>

      <Section heading="7. Data Retention" testid="privacy-data-retention">
        <p>
          PITCHD keeps personal data only for as long as necessary to provide services, comply with legal
          obligations, resolve disputes, and enforce agreements.
        </p>
      </Section>

      <Section heading="8. User Rights" testid="privacy-user-rights">
        <p>
          Users may request access, correction, deletion, or export of their personal data.
        </p>
      </Section>

      <Section heading="9. Cookies and Analytics" testid="privacy-cookies">
        <p>
          PITCHD may use cookies and analytics tools to improve product performance and understand platform
          usage.
        </p>
      </Section>

      <Section heading="10. Security" testid="privacy-security">
        <p>
          PITCHD uses reasonable technical and organisational measures to protect user data.
        </p>
      </Section>

      <Section heading="11. Children and Minors" testid="privacy-children">
        <p>
          If athletes under 18 use the platform, parental or guardian consent may be required depending on
          applicable law.
        </p>
      </Section>

      <Section heading="12. Contact" testid="privacy-contact">
        <p>
          For any questions about this Privacy Policy, contact{" "}
          <a className="text-volt" href="mailto:privacy@pitchdhq.com">privacy@pitchdhq.com</a>.
        </p>
      </Section>
    </LegalLayout>
  );
}
